import ExternalDeliveryFileRegister from '@components/file-register/external-delivery-files';

const ExternalDeliveryFileRegisterPage = () => {
  return <ExternalDeliveryFileRegister />;
};

export default ExternalDeliveryFileRegisterPage;
